var map = {
	"./en": [
		"edd4",
		3
	],
	"./en.json": [
		"edd4",
		3
	],
	"./entity": [
		"9732",
		9
	],
	"./entity.js": [
		"9732",
		9
	],
	"./fr": [
		"f693",
		3
	],
	"./fr.json": [
		"f693",
		3
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "326a";
module.exports = webpackAsyncContext;